<template>
  <v-chip small outlined>
    {{ label }}
  </v-chip>
</template>
<script>
export default {
  props: ["item"],
  computed: {
    label() {
      return this.item._kind === "created"
        ? this.$t("operatingInstructions.kind.created")
        : this.$t("operatingInstructions.kind.uploaded");
    },
  },
};
</script>
